import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { push } from "connected-react-router"
import { makeStyles } from "@material-ui/core/styles"
import { AppBar, Toolbar, IconButton, MenuItem, Menu, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, Divider, Grid, Fab } from "@material-ui/core"
import CloseIcon from "@material-ui/icons/Close"
import { useIdleTimer } from 'react-idle-timer'
import Badge from "@mui/material/Badge"
import _ from "lodash"

import AccountCircle from "@material-ui/icons/AccountCircle"
import MailIcon from "@material-ui/icons/Mail"
import NotificationsIcon from "@material-ui/icons/Notifications"
import MoreIcon from "@material-ui/icons/MoreVert"

import * as authActions from "../../actions/authActions"
import NotificationDrawer from "../partials/NotificationDrawer"
import ProfileDrawer from "../partials/ProfileDrawer"
import ProfileMenu from "./ProfileMenu"

// 20 minutes
const timeout = 1_200_000
// 5 minutes
const promptBeforeIdle = 300_000
const TopBar = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [profileAnchorEl, setProfileAnchorEl] = React.useState(null)
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)
  const [notificationDrawer, setNotificationDrawer] = React.useState(false)
  const [openProfileDrawer, setOpenProfileDrawer] = React.useState(false)
  const notificationCount = useSelector((state) => state.userInfo.settings.user?.rentalErrorMessageHistory?.length)
  const errors = useSelector((state) => state.userInfo.settings.user?.rentalErrorMessageHistory)
  const userType = useSelector((state) => state.userInfo.settings.user?.userType)

  const currentPathname = useSelector((state) => state.router.location.pathname)
  const matches = currentPathname.match(/(\/bookings\/manage|\/bookings\/create|\/controlpanel|\/dashboard)/g)
  const tabValue = Boolean(matches) && matches[0] ? matches[0] : false
  const [currentTab, setCurrentTab] = React.useState(tabValue)
  const dispatch = useDispatch()
  let path = window.location.pathname
  path = path.split("/")
  const brand = _.toLower(path[1])

  const isMenuOpen = Boolean(anchorEl)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

  const [willExpire, setWillExpire] = React.useState(false)

  const onIdle = () => {
    dispatch(authActions.logout())
    setWillExpire(false)
  }

  const onActive = () => {
    setWillExpire(false)
  }

  const onPrompt = () => {
    setWillExpire(true)
  }
  const { activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500
  })

  function handleTabChange(event, newValue) {
    dispatch(push({ pathname: "/" + location.pathname.split("/")[1] + newValue }))
    setCurrentTab(newValue)
  }

  function handleProfileClick(event) {
    setProfileAnchorEl(event.currentTarget)
  }

  function handleProfileClose() {
    setProfileAnchorEl(null)
  }

  function handleProfileMenuOpen() {
    setOpenProfileDrawer(true)
    // setAnchorEl(event.currentTarget)
  }

  function handleMobileMenuClose() {
    setMobileMoreAnchorEl(null)
  }

  function handleMenuClose() {
    setAnchorEl(null)
    handleMobileMenuClose()
  }

  function handleMobileMenuOpen(event) {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const handleLogout = () => {
    dispatch(authActions.logout())
  }

  function handleViewProfile() {
    dispatch(push({ pathname: "/" + location.pathname.split("/")[1] + "/profile" }))
    setCurrentTab("/profile")
  }

  function handleNotification() {
    setNotificationDrawer(true)
  }

  function handleChangePassword() {
    dispatch(push({ pathname: "/" + location.pathname.split("/")[1] + "/changePassword" }))
    setCurrentTab("/changePassword")
  }

  const menuId = "primary-search-account-menu"
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>My Profile</MenuItem>
      <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
      {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
      <MenuItem onClick={handleLogout}>Logout</MenuItem>
    </Menu>
  )

  const mobileMenuId = "primary-search-account-menu-mobile"
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {" "}
      <MenuItem>
        <IconButton aria-label="show 4 new mails">
          <Badge badgeContent={4} style={{ color: "white" }}>
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 5 new notifications">
          <Badge badgeContent={5} style={{ color: "white" }}>
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
        >
          {" "}
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <IconButton aria-controls="primary-search-account-menu" aria-haspopup="true">
          {" "}
          <AccountCircle />
        </IconButton>
        <p>Logout</p>
      </MenuItem>
    </Menu>
  )

  return (
    <div className={classes.grow}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <div style={{ marginLeft: "10px", marginTop: 2 }}>
            <img src={`${"/i18n/hertzlogo-light.png"}`} height="34px" />
          </div>
          <div className={classes.grow}>
            <Tabs value={currentTab} onChange={handleTabChange} indicatorColor="secondary" centered>
              <Tab value="/dashboard" label="Dashboard" />
              <Tab value="/bookings/create" label="Create A Booking" />
              <Tab value="/bookings/manage" label="Manage Bookings" />
              {userType != "SERVICE_USER" && <Tab value="/controlpanel" label="Control Panel" />}
            </Tabs>
          </div>
          <div className={classes.sectionDesktop}>
            <IconButton aria-label="show new notifications" onClick={handleNotification}>
              <Badge badgeContent={notificationCount} color="secondary">
                <NotificationsIcon style={{ color: "white" }} />
              </Badge>
            </IconButton>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileClick}
            >
              {" "}
              <AccountCircle style={{ color: "white" }} />
            </IconButton>
            
          </div>
          <div style={{ marginLeft: "20px" }}>
            <img src={`https://static.hertz.asiapac.io/mybookingportal/${brand}-light-logo.png`} height="25px" />
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
            >
              {" "}
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
        <NotificationDrawer
          open={notificationDrawer}
          setNotificationDrawer={setNotificationDrawer}
          errors={errors}
        ></NotificationDrawer>
        <ProfileDrawer
          open={openProfileDrawer}
          setOpenProfileDrawer={setOpenProfileDrawer}
          errors={errors}
        ></ProfileDrawer>
        
        <ProfileMenu
          anchorEl={profileAnchorEl}
          handleClose={handleProfileClose}
          handleChangePassword={handleChangePassword}
          handleViewProfile={handleViewProfile}
          handleLogout={handleLogout}
        />
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <Dialog open={willExpire}>
          <DialogTitle style={{ textAlign: "center" }}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={() => setWillExpire(false)}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            Your session will expire in 5 minutes.
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Divider />
            <Grid spacing={1} container direction="row" justifyContent="center">
              <Grid container item xs={12} justifyContent="center">
                <Fab
                  color="primary"
                  variant="extended"
                  onClick={() => activate()}
                >
                  Extend My Session
                </Fab>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: 99, //theme.zIndex.drawer + 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    color: "#ffd100",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}))

export default TopBar
